document.addEventListener("DOMContentLoaded", (event) => {
  init();
});

const productBackInStockInput = document.querySelector('[js-product="backInStockInput"]');
const productBackInStockSubmit = document.querySelector('[js-product="backInStockSubmit"]');

function init() {
  setEventListeners();
}

function setEventListeners() {
  if (productBackInStockSubmit) {
    productBackInStockSubmit.addEventListener("click", () => {
      handleProductBackInStockSubmission()
    });
  }
}

function handleProductBackInStockSubmission() {
  if (!productBackInStockInput) {
    return;
  }

  const inputValue = productBackInStockInput.value

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(inputValue)) {
    return;
  }

  submitKlaviyoBIS(inputValue);
}

function submitKlaviyoBIS(email) {
  const variantId = productBackInStockSubmit.dataset?.variantId

  if (!variantId) {
    return;
  }

  const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      revision: '2023-10-15',
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {data: {type: 'profile', attributes: {email: email}}}
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    })
  };
  
  fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=T4CsxK', options)
    .then(response => {
      console.log(response)
      if (!response.status == 202) {
        return
        throw new Error('Network response was not ok');
      }
      
      const buttonMessage = productBackInStockSubmit.querySelector('span')

      if (!buttonMessage) {
        return
      }

      buttonMessage.innerText = 'Subscribed'
      buttonMessage.disabled = true
    })
    .catch(err => {
      console.error('Error:', err);
    });
}